import * as React from 'react';
import { CaptionAccentTypography, CaptionTypography, Input } from 'ui';
import { cn } from '@utils';

type Props = {
	type: string;
	label: string;
	name?: string;
	error?: string;
	endAdornment?: React.ReactNode;
} & Omit<React.ComponentProps<typeof Input>, 'size'>;

export const BaseInput: React.FC<Props> = ({ label, error, endAdornment, className, ...props }) => {
	const errorClassName = error ? 'border-error' : '';

	const errorComponent: React.ReactNode = error ? (
		<div className="flex flex-row items-start justify-start gap-[0.25rem]">
			<CaptionTypography className="overflow-auto text-wrap text-error">{error}</CaptionTypography>
		</div>
	) : null;

	return (
		<div className="flex w-full flex-col gap-[0.25rem]">
			<CaptionAccentTypography className="text-primary">{label}</CaptionAccentTypography>
			<div
				className={cn(
					'relative flex w-full items-center rounded-2xl border-2 border-borderPrimary bg-white',
					className,
					errorClassName
				)}
			>
				<Input
					variant="naked"
					width="100%"
					size="md"
					color="black"
					className={cn('w-full py-2 pl-2', endAdornment ? '!pr-9' : 'pr-2')}
					{...props}
				/>
				{endAdornment ? <div className="absolute right-2 flex items-center">{endAdornment}</div> : null}
			</div>
			{errorComponent}
		</div>
	);
};
